import { useState } from 'react';

const testimonials = [
  {
    quote: "Monarch Xpress has been our go-to freight partner for over 3 years. Their reliability and professionalism are unmatched. Every delivery arrives on time, and their communication is exceptional.",
    name: "Michael Rodriguez",
    company: "Southwest Manufacturing Co.",
    title: "Logistics Director",
    image: "https://public.readdy.ai/ai/img_res/158eade9e87239c454ee99d1d15296d5.jpg"
  },
  {
    quote: "We've worked with many carriers, but Monarch Xpress stands out for their attention to detail and customer service. They treat our freight like it's their own. Highly recommended for any business needing dependable transportation.",
    name: "Sarah Chen",
    company: "Texas Distribution Partners",
    title: "Supply Chain Manager",
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20business%20executive%20in%20modern%20office%2C%20confident%20supply%20chain%20manager%2C%20corporate%20portrait%2C%20professional%20headshot%2C%20simple%20background&width=400&height=600&seq=testimonial-client-2&orientation=portrait"
  },
  {
    quote: "The team at Monarch Xpress goes above and beyond. Their cross-dock and warehousing services have streamlined our operations significantly. We've reduced costs and improved delivery times across the board.",
    name: "James Patterson",
    company: "National Retail Solutions",
    title: "Operations Manager",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20business%20executive%20in%20warehouse%20setting%2C%20confident%20operations%20manager%2C%20corporate%20portrait%2C%20professional%20headshot%2C%20simple%20background&width=400&height=600&seq=testimonial-client-3&orientation=portrait"
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 px-6 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2 relative">
            <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl transform lg:-translate-y-12">
              <img
                src={current.image}
                alt={current.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-green-400 text-8xl mb-6 font-serif">"</div>
            <blockquote className="text-2xl md:text-3xl text-white leading-relaxed mb-8 font-light">
              {current.quote}
            </blockquote>
            <div className="mb-8">
              <div className="text-xl font-bold text-white mb-1">{current.name}</div>
              <div className="text-sm text-gray-400">{current.title}</div>
              <div className="text-sm text-gray-500">{current.company}</div>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={prevTestimonial}
                className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-white text-xl"></i>
              </button>
              <button
                onClick={nextTestimonial}
                className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </button>
              <div className="flex gap-2 ml-4">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      index === currentIndex ? 'bg-green-600 w-8' : 'bg-white/30'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}